import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";
import AppModal from "components/shared/modal/AppModal";

import { postChangeAgentAutoupdate } from "redux/handlers/serverHandler";

import { useAppDispatch } from "hooks/reduxHook";

const AgentAutoUpdate = ({ id }: { id: number }) => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [openModal, setOpenModal] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [autoValue, setAutoValue] = useState<number>(0);

 const handleOpen = () => setOpenModal(true);
 const handleClose = () => setOpenModal(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(postChangeAgentAutoupdate(id, formatFrequency()));
  setLoading(false);
  handleClose();
 };

 const formatFrequency = (): string => {
  switch (autoValue) {
   case 0:
    return "disabled";
   case 1:
    return "weekly";
   case 2:
    return "monthly";
   default:
    return "disabled";
  }
 };

 return (
  <>
   <Tooltip title={intl.formatMessage({ id: "server.manage.editAutoAgentUpdate" })}>
    <IconButton onClick={handleOpen}>
     <IconSelector icon="EditIcon" props={{ sx: { fontSize: 12 }, color: "kxOrange" }} />
    </IconButton>
   </Tooltip>
   <AppModal
    open={openModal}
    close={handleClose}
    handleClose={handleClose}
    disabled={loading}
    handleConfirm={handleConfirm}
    title={intl.formatMessage({ id: "server.manage.editAutoAgentUpdate" })}>
    <Stack>
     <Typography variant="subtitle2">
      <FormattedMessage id="server.manage.editAutoAgentUpdateMessage" />
     </Typography>
     <RadioGroup value={autoValue} onChange={(e, value) => setAutoValue(Number(value))}>
      <FormControlLabel
       value={0}
       control={<Radio />}
       label={<FormattedMessage id="server.manage.disabled" />}
      />
      <FormControlLabel
       value={1}
       control={<Radio />}
       label={<FormattedMessage id="server.manage.weekly" />}
      />
      <FormControlLabel
       value={2}
       control={<Radio />}
       label={<FormattedMessage id="server.manage.monthly" />}
      />
     </RadioGroup>
    </Stack>
   </AppModal>
  </>
 );
};

export default AgentAutoUpdate;
